import React from 'react';

import { startOfDay, endOfDay } from 'date-fns';

import { DatePicker } from 'uiToolkitV1/DatePicker';
import InputLabel from 'uiToolkitV1/InputLabel';

import { ReadOnlyCalendarInput } from './ReadOnlyCalendarInput';

export const OKRStartDateComponent = ({
  startTS = new Date(),
  dueTS,
  onChange = () => {},
  timeBoundDetails,
  isReadOnly,
  customInputProps = {},
}) => {
  const startDate = startOfDay(new Date(startTS));
  const minDate = startOfDay(new Date(timeBoundDetails?.startTS));

  const timeBoundDetailsEndTS = timeBoundDetails?.endTS;
  const maxDate = endOfDay(new Date(Math.min(dueTS, timeBoundDetailsEndTS)));

  const handleDateChange = (selectedDate) => {
    onChange(startOfDay(selectedDate).valueOf());
  };

  return (
    <>
      {isReadOnly ? (
        <ReadOnlyCalendarInput selectedDate={startDate} />
      ) : (
        <DatePicker
          onChange={handleDateChange}
          selectedDate={startDate}
          popperPlacement="auto"
          minDate={minDate}
          maxDate={maxDate}
          customInputProps={customInputProps}
        />
      )}
    </>
  );
};

export const OKRStartDate = ({
  startTS = new Date(),
  dueTS,
  onChange = () => {},
  timeBoundDetails,
  isReadOnly,
  customInputProps = {},
}) => (
  <InputLabel labelText="Start by">
    <OKRStartDateComponent
      startTS={startTS}
      dueTS={dueTS}
      onChange={onChange}
      timeBoundDetails={timeBoundDetails}
      isReadOnly={isReadOnly}
      customInputProps={customInputProps}
    />
  </InputLabel>
);
